import { render, staticRenderFns } from "./IconInterface.vue?vue&type=template&id=652b4463&"
import script from "./IconInterface.vue?vue&type=script&lang=js&"
export * from "./IconInterface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('652b4463')) {
      api.createRecord('652b4463', component.options)
    } else {
      api.reload('652b4463', component.options)
    }
    module.hot.accept("./IconInterface.vue?vue&type=template&id=652b4463&", function () {
      api.rerender('652b4463', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconInterface.vue"
export default component.exports